var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "userCenter"
  }, [_c('m-head'), _c('div', {
    staticClass: "userCenter-main page-main"
  }, [_c('div', {
    staticClass: "upgrade-info"
  }, [_c('div', {
    staticClass: "upgrade-info-main"
  }, [_c('img', {
    staticClass: "wow bounce",
    attrs: {
      "data-wow-duration": "0.8s",
      "src": require(`@images/avatar/body/${_vm.gameProgress.currentLevel >= _vm.botImgLimit ? _vm.botImgLimit : _vm.gameProgress.currentLevel}.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info__label"
  }, [_vm._v("ID")]), _c('div', {
    staticClass: "info__value"
  }, [_vm._v(_vm._s(_vm.userInfo.id))])]), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info__label"
  }, [_vm._v("Airdroppass")]), _c('div', {
    staticClass: "info__value"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.airdrop_ticket)))])])]), _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-main"
  }, [_vm._v("Lv." + _vm._s(_vm.gameProgress.currentLevel))])]), _c('div', {
    staticClass: "intro"
  }, [_c('m-tier-benefits')], 1)])]), _c('div', {
    staticClass: "hum-more"
  }, [_c('div', {
    staticClass: "hum-more__title"
  }, [_vm._v(" Complete: "), _c('span', [_vm._v(_vm._s(_vm.didInfo?.completion?.completion_rate * 100) + "%")])]), _c('div', {
    staticClass: "hum-more__sub"
  }, [_vm._v("Complete your personal information to earn more rewards")]), _c('div', {
    staticClass: "hum-more-main"
  }, _vm._l(_vm.didInfo.categories, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "items-bg",
      class: item?.tasks && item.tasks[0].type == 'facescan' ? 'hum-more-face' : 'hum-more-items'
    }, [item?.tasks && item.tasks[0].type == 'facescan' ? void 0 : [_c('div', {
      staticClass: "hum-more-items-main items-bg-main"
    }, [_c('div', {
      staticClass: "hum-more-items__title"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "hum-more__reward"
    }, [item.tasks.reduce((acc, cur) => acc + cur.reward, 0) > 0 ? _c('span', [_c('img', {
      attrs: {
        "src": require(`@images/icon/icon-hic.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm.fmt_pre(item.tasks.reduce((acc, cur) => acc + cur.reward, 0))))]) : _vm._e(), item.tasks.reduce((acc, cur) => acc + cur.reward_spins, 0) > 0 ? _c('span', [_c('img', {
      attrs: {
        "src": require(`@images/SPINS.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm.fmt_pre(item.tasks.reduce((acc, cur) => acc + cur.reward_spins, 0))))]) : _vm._e()]), _c('div', {
      staticClass: "hum-more-list"
    }, _vm._l(item.tasks, function (itm, idx) {
      return _c('div', {
        key: idx,
        staticClass: "hum-more-item wow fadeInUp",
        attrs: {
          "data-wow-duration": `${0.2 + idx / 10}s`
        },
        on: {
          "click": function ($event) {
            return _vm.onShowPop(itm);
          }
        }
      }, [_c('div', {
        staticClass: "hum-more-item-main",
        class: !itm.completed && 'ok'
      }, [_c('div', {
        staticClass: "hum-more__icon"
      }, [_c('img', {
        attrs: {
          "src": itm.icon,
          "alt": ""
        }
      })]), _c('div', {
        staticClass: "hum-more__label"
      }, [_vm._v(_vm._s(itm.title))]), itm.completed ? _c('div', {
        staticClass: "hum-more__status"
      }, [_c('svg-icon', {
        attrs: {
          "name": "icon-ok"
        }
      })], 1) : _vm._e()])]);
    }), 0)])]], 2);
  }), 0)])]), _c('m-menu'), _c('pop-prompt', {
    attrs: {
      "title": " ",
      "show": _vm.popPromptShow,
      "isDisableConfirm": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isDisableConfirm') && _vm.popPromptInfo.isDisableConfirm,
      "isConfirmLoading": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isConfirmLoading') && _vm.popPromptInfo.isConfirmLoading,
      "isBtnCancel": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('cancelText') && _vm.popPromptInfo.cancelText != null,
      "content": "html",
      "cancelText": _vm.popPromptInfo ? _vm.popPromptInfo.cancelText : ' ',
      "isBtnConfirm": _vm.popPromptInfo && _vm.popPromptInfo.confirmText,
      "confirmText": _vm.popPromptInfo ? _vm.popPromptInfo.confirmText : ' '
    },
    on: {
      "update:show": function ($event) {
        _vm.popPromptShow = $event;
      },
      "cancel": function ($event) {
        _vm.popPromptInfo && _vm.popPromptInfo.cancelText && _vm.popPromptInfo.hasOwnProperty('cancelFn') && _vm.popPromptInfo.cancelFn();
      },
      "confirm": function ($event) {
        _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('confirmFn') && _vm.popPromptInfo.confirmFn();
      }
    },
    scopedSlots: _vm._u([{
      key: "limit",
      fn: function () {
        return [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('resubmission') && _vm.popPromptInfo.resubmission ? _c('div', {
          staticClass: "pop-centertask__res",
          domProps: {
            "innerHTML": _vm._s(_vm.popPromptInfo.resubmission)
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pop-centertask"
  }, [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('icon') && _vm.popPromptInfo.icon ? _c('div', {
    staticClass: "pop-centertask__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.popPromptInfo.icon,
      "alt": ""
    }
  })]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('title') && _vm.popPromptInfo.title ? _c('div', {
    staticClass: "pop-centertask__title"
  }, [_vm._v(_vm._s(_vm.popPromptInfo.title))]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('sub') && _vm.popPromptInfo.sub ? _c('div', {
    staticClass: "pop-centertask__sub"
  }, [_vm._v(_vm._s(_vm.popPromptInfo.sub))]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('info') && _vm.popPromptInfo.info ? _c('div', {
    staticClass: "pop-centertask__info"
  }, [_vm._v(_vm._s(_vm.popPromptInfo.info))]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('reward') && _vm.popPromptInfo.reward ? _c('div', {
    staticClass: "pop-centertask__reward",
    domProps: {
      "innerHTML": _vm._s(_vm.popPromptInfo.reward)
    }
  }) : _vm._e(), _vm.selectRow && _vm.selectRow.editable ? _c('div', {
    staticClass: "pop-centertask__input"
  }, [_vm.selectRow && _vm.selectRow.type === 'wallet' && _vm.selectRow.title == 'TON' ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mediaInput,
      expression: "mediaInput"
    }],
    class: _vm.isEdit && 'disabled',
    attrs: {
      "placeholder": `Please connect ${_vm.selectRow.title}`
    },
    domProps: {
      "value": _vm.mediaInput
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.mediaInput = $event.target.value;
      }, _vm.onInput]
    }
  }), _vm.tonConnect ? _c('div', {
    staticClass: "icon-quit",
    on: {
      "click": _vm.onTonnectQuit
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-quit"
    }
  })], 1) : _vm._e()] : _vm.selectRow && _vm.selectRow.title != 'TON' ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mediaInput,
      expression: "mediaInput"
    }],
    ref: "inputRef",
    class: _vm.selectRow && _vm.selectRow.completed && _vm.isEdit && 'disabled',
    attrs: {
      "placeholder": `Please enter ${_vm.selectRow.title}`
    },
    domProps: {
      "value": _vm.mediaInput
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.mediaInput = $event.target.value;
      }, _vm.onInput]
    }
  }), _vm.selectRow && _vm.selectRow.completed ? _c('div', {
    staticClass: "icon-edit",
    on: {
      "click": _vm.onEdit
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-edit"
    }
  })], 1) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm.selectRow && !_vm.selectRow.editable ? [_vm.selectRow.title == 'Telegram' ? _c('div', {
    staticClass: "pop-centertask__head"
  }, [_c('div', {
    staticClass: "pop-centertask__img"
  }, [_c('m-head-img', {
    attrs: {
      "name": _vm.userInfo,
      "bgColor": _vm.userInfo.head_color
    }
  })], 1), _c('div', {
    staticClass: "pop-centertask__name"
  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))])]) : _vm._e()] : _vm._e()], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };